import { Route } from '@angular/router';

import { CompanyGroupsViewComponent } from './company-groups/company-groups-view.component';
import { GroupsComponent } from './groups.component';

export const groupsRoutes: Route[] = [
  {
    path: '',
    component: GroupsComponent,
    children: [
      {
        path: '',
        component: CompanyGroupsViewComponent
        // children: [
        //   {
        //     path: 'preview/:id',
        //     component: UserDetailsComponent
        //   }
        // ]
      }
      // {
      //   path: 'create',
      //   component: UserCreateComponent,
      //   data: {
      //     breadcrumb: 'Create'
      //   }
      // },
      // {
      //   path: 'edit/:id',
      //   component: UserEditComponent,
      //   data: {
      //     breadcrumb: 'Edit'
      //   }
      // }
    ]
  }
];
